import { render, staticRenderFns } from "./ForumReplyIcon.vue?vue&type=template&id=1f21ba6b&scoped=true"
import script from "./ForumReplyIcon.vue?vue&type=script&lang=js"
export * from "./ForumReplyIcon.vue?vue&type=script&lang=js"
import style0 from "./ForumReplyIcon.vue?vue&type=style&index=0&id=1f21ba6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21ba6b",
  null
  
)

export default component.exports